/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export enum MetricsEnum {
    CPU = 'cpu',
    NETWORKGRAPH = 'Network Graph',
    LOADAVERAGEGRAPH = 'System Load Average',
    MEMORYGRAPH = 'System Memory usage',
    CONNECTIONS = 'connections',
    MEMORY = 'memory',
    DISKS = 'disks',
    INTERFACES = 'interfaces',
    VIRTUALSERVICES = 'Virtual servers',
}
